import { IAnalyticsEvent } from 'affiny-core/analytics';

declare global {
  // tslint:disable-next-line: interface-name
  interface Window {
    dataLayer: object[];
  }
}

export enum EGTM_CUSTOM_EVENTS {
  PAGE_VIEW = 'VirtualPageview',
  EVENT = 'GAevent',
}

export enum EGTM_EVENT_CATEGORY {
  USER_INTERACTION = 'USER_INTERACTION',
}

export enum EGTM_EVENT_ACTION {
  SEND = 'Send',
}

export enum EGTM_EVENT_LABEL {
  FULLPAGE_MEMBER_CARD_FAVORITE_SENT = 'FULLPAGE_MEMBER_CARD_FAVORITE_SENT',
}

export interface IGtmPageViewParameters {
  /**
   * virtual page view name (setup in GTM variable config)
   */
  vpvName: string;
}

export interface IGtmEventParameters extends IAnalyticsEvent {
  eventValue?: string;
}
